import { 
  PIPE_RECEIVE_REQUEST, 
  CREATE_PIPE_RECEIVE, 
  GET_PIPE_RECEIVES, 
  GET_PIPE_RECEIVES_PAGE, 
  UPDATE_PIPE_RECEIVE, 
  DELETE_PIPE_RECEIVE, 
  PIPE_RECEIVE_REQUEST_FAILURE, 
  PIPE_RECEIVE_REQUEST_SUCCESS 
} from '../types';

const initialState = {
  pipeReceives: [],
  pipeReceivesPage: [],
  loading: false,
  error: null,
};


const pipeReceiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case PIPE_RECEIVE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PIPE_RECEIVES: {
      return {
        ...state,
        pipeReceives: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PIPE_RECEIVES_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
        ...state,
        pipeReceivesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
        }
    }
    case CREATE_PIPE_RECEIVE:
      return {
        ...state,
        pipeReceives: [action.payload, ...state.pipeReceives],
        loading: false,
        error: null
      };
    case UPDATE_PIPE_RECEIVE:
      const pipeReceivesData = state.pipeReceives.slice(0);
      const uIndex = pipeReceivesData.findIndex((data) => data.id === action.payload.id);
      pipeReceivesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        pipeReceives: [ ...pipeReceivesData ],
        loading: false,
        error: null
      };
    case DELETE_PIPE_RECEIVE:
      const pipeReceives = state.pipeReceives?.slice(0);
      const index = pipeReceives.findIndex((data) => data.id === action.id);
      if (index > -1) {
        pipeReceives.splice(index, 1);
      }
      return {
        ...state,
        pipeReceives: [...pipeReceives],
        loading: false,
        error: null
      }
    case PIPE_RECEIVE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case PIPE_RECEIVE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default pipeReceiveReducer;
